import { render, staticRenderFns } from "./CardColaboracaoAprovada.vue?vue&type=template&id=38f08c2b"
import script from "./CardColaboracaoAprovada.vue?vue&type=script&lang=js"
export * from "./CardColaboracaoAprovada.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports